import { Controller, Control, FieldValues, Path } from 'react-hook-form'
import { TextField, TextFieldProps, MenuItem } from '@mui/material'

type SelectOption = {
  value: string
  label: string
}

type CustomSelectProps<T extends FieldValues> = {
  name: Path<T>
  control: Control<T>
  options: SelectOption[]
  defaultValue?: string
  sx?: TextFieldProps['sx']
  SelectProps?: TextFieldProps['SelectProps']
} & Omit<TextFieldProps, 'name' | 'select' | 'children' | 'sx' | 'SelectProps'>

const CustomSelect = <T extends FieldValues>({
  name,
  control,
  options,
  defaultValue = '',
  sx,
  SelectProps,
  ...textFieldProps
}: CustomSelectProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue as any}
      render={({ field }) => (
        <TextField
          {...field}
          {...textFieldProps}
          select
          fullWidth
          size="small"
          InputLabelProps={{ ...textFieldProps.InputLabelProps }}
          SelectProps={SelectProps}
          sx={sx}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  )
}

export default CustomSelect
